/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangeLeadRequest
 */
export interface ExchangeLeadRequest {
    /**
     * 
     */
    target_facility_id: string;
}

/**
 * Check if a given object implements the ExchangeLeadRequest interface.
 */
export function instanceOfExchangeLeadRequest(value: object): value is ExchangeLeadRequest {
    if (!('target_facility_id' in value) || value['target_facility_id'] === undefined) return false;
    return true;
}

export function ExchangeLeadRequestFromJSON(json: any): ExchangeLeadRequest {
    return ExchangeLeadRequestFromJSONTyped(json, false);
}

export function ExchangeLeadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeLeadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target_facility_id': json['target_facility_id'],
    };
}

export function ExchangeLeadRequestToJSON(json: any): ExchangeLeadRequest {
    return ExchangeLeadRequestToJSONTyped(json, false);
}

export function ExchangeLeadRequestToJSONTyped(value?: ExchangeLeadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_facility_id': value['target_facility_id'],
    };
}

